{
  "version": 1,
  "asset_id": "9b2d0e27-b01e-473a-8735-832c3a364074",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/9b2d0e27-b01e-473a-8735-832c3a364074/wordpress.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/9b2d0e27-b01e-473a-8735-832c3a364074/wordpress.svg",
  "original_filename": "wordpress.svg",
  "size": 273,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-18T13:52:15Z"
}
